import {
  LOADING_TIMESHEET,
  LOAD_TIMESHEET,
  FETCH_TIMESHEET_REQUEST,
  FETCH_TIMESHEET_REQUEST_SUCCESS,
  TIMESHEET_SAVE_REQUEST,
  TIMESHEET_SAVE_SUCCESS,
  PROFILE_SAVE_REQUEST,
  PROFILE_SAVE_SUCCESS,
  TIMESHEET_EMPLOYEE_NAME_LIST,
  TIMESHEET_EMPLOYEE_FACILITIES,
  TIMESHEET_SCHEDULE_LIST,
  CLEAR_TIMESHEET_SCHEDULE_LIST,
  LOADING_TIMESHEET_SUCCESS,
  SET_IS_ADD_TIMESHEET_CONFIRM_DIALOG_OPEN,
  LOAD_TIMESHEET_INVOICES,
  LOAD_TIMESHEET_PAYROLLS,
  LOAD_REQUESTED_PAYROLL_TIMESHEETS,
  REPLACE_SELECTED_TIMESHEET_INVOICE,
  RESTORE_TIMESHEETS,
  REPLACE_SELECTED_TIMESHEET_PAYROLL,
  LOAD_TIMESHEET_REGIONS,
  REPLACE_SELECTED_TIMESHEET_REGION,
} from "../types/timesheet.types";
import { ICompany, ICompanyLocation } from "./company.reducer";
import { IPeople } from "./people.reducer";

export interface NameList {
  fullname: string;
  id: string;
  email:string;
}

export interface ITimesheet {
  employee: IPeople;
  facility_location: ICompanyLocation;
  authorized_wardnamnager: string;
  break_time: string;
  holiday_name: string;
  id: string;
  is_holiday: boolean;
  shift: string;
  shift_comments: string;
  shift_end_date: string;
  shift_end_time: string;
  shift_start_date: string;
  shift_start_time: string;
  subsidiary: number;
  total_hours: string;
  shift_end_lat_lang: string;
  shift_start_lat_lang: string;
  facility: ICompany;
  facility_name: ICompany["facility_name"];
  user_role: string;
  shift_start_location: string;
  shift_end_location: string;
  system_start_date: string;
  system_end_date: string;
  location: string;
  payroll_type: string;
  invoice_type: string;
  region: string;
}

export interface IPayroll {
  EarningsRateID: string;
  Name: string;
}

export interface IInvoice {
  Code: string;
  ItemID: string;
}

export interface IRegion {
  TrackingOptionID: string;
  Name: string;
}

export type timesheetStateType = {
  timesheets: null | ITimesheet[];
  timesheet: null | ITimesheet;
  total: number;
  current: number;
  loading: boolean;
  save: boolean;
  employeenames: NameList[];
  facilities: ICompany[];
  schedules: any[];
  isConfirmAddTimesheetDialogOpen: boolean;
  payrolls: IPayroll[];
  invoices: IInvoice[];
  regions: IRegion[];
};

const initialState: timesheetStateType = {
  timesheets: null,
  timesheet: null,
  total: 0,
  current: 1,
  loading: false,
  save: false,
  employeenames: [],
  facilities: [],
  schedules: [],
  isConfirmAddTimesheetDialogOpen: false,
  payrolls: [],
  invoices: [],
  regions: [],
};

export default function timesheetReducer(state = initialState, action: any) {
  switch (action.type) {
    case LOAD_TIMESHEET:
      return {
        ...state,
        loading: false,
        save: false,
        timesheets: action.payload.results,
        total: action.payload.count,
        current: action.payload.current,
      };
    case LOADING_TIMESHEET:
      return {
        ...state,
        loading: true,
      };

    case LOAD_TIMESHEET_INVOICES:
      return {
        ...state,
        invoices: action.payload,
      };
    case LOAD_TIMESHEET_PAYROLLS:
      return {
        ...state,
        payrolls: action.payload,
      };

    case LOAD_TIMESHEET_REGIONS:
      return {
        ...state,
        regions: action.payload,
      };
    case LOADING_TIMESHEET_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case FETCH_TIMESHEET_REQUEST:
      return {
        ...state,
        timesheet: null,
        loading: true,
      };
    case FETCH_TIMESHEET_REQUEST_SUCCESS:
      return {
        ...state,
        loading: false,
        timesheet: action.payload,
      };
    case TIMESHEET_SAVE_REQUEST:
      return {
        ...state,
        save: false,
      };
    case TIMESHEET_SAVE_SUCCESS:
      return {
        ...state,
        save: true,
        timesheet: null,
      };
    case PROFILE_SAVE_REQUEST:
      return {
        ...state,
        save: true,
      };
    case PROFILE_SAVE_SUCCESS:
      return {
        ...state,
        save: false,
      };
    case TIMESHEET_EMPLOYEE_NAME_LIST:
      return {
        ...state,
        employeenames: action.payload,
      };
    case TIMESHEET_SCHEDULE_LIST:
      return {
        ...state,
        schedules: action.payload,
      };
    case CLEAR_TIMESHEET_SCHEDULE_LIST:
      return {
        ...state,
        schedules: [],
      };
    case TIMESHEET_EMPLOYEE_FACILITIES:
      return {
        ...state,
        facilities: action.payload,
      };

    case SET_IS_ADD_TIMESHEET_CONFIRM_DIALOG_OPEN:
      return {
        ...state,
        isConfirmAddTimesheetDialogOpen: action.payload,
      };

    case LOAD_REQUESTED_PAYROLL_TIMESHEETS:
      return {
        ...state,
        timesheets: action.payload,
      };

    case REPLACE_SELECTED_TIMESHEET_INVOICE:
      let timesheets = state?.timesheets;
      let newTimesheets = timesheets?.map((timesheet) => {
        if (timesheet.id === action.payload?.id) {
          timesheet.invoice_type = action.payload?.invoice_type;
        }
        return timesheet;
      });

      return {
        ...state,
        timesheets: newTimesheets,
      };

    case REPLACE_SELECTED_TIMESHEET_PAYROLL:
      let oldTimesheets = state?.timesheets;
      let newUpdatedTimesheets = oldTimesheets?.map((timesheet) => {
        if (timesheet.id === action.payload?.id) {
          timesheet.payroll_type = action.payload?.payroll_type;
        }
        return timesheet;
      });

      return {
        ...state,
        timesheets: newUpdatedTimesheets,
      };

    case REPLACE_SELECTED_TIMESHEET_REGION:
      let allTimesheets = state?.timesheets;
      let newTimesheetsList = allTimesheets?.map((timesheet) => {
        if (timesheet.id === action.payload?.id) {
          timesheet.region = action.payload?.region;
        }
        return timesheet;
      });

      return {
        ...state,
        timesheets: newTimesheetsList,
      };

    case RESTORE_TIMESHEETS:
      let copyTimesheets = JSON.stringify(state.timesheets);
      let parsedTimesheet = JSON.parse(copyTimesheets);
      return {
        ...state,
        timesheets: parsedTimesheet,
      };
    default:
      return state;
  }
}
